import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { DocumentDao } from '@app/dao/document/document.dao';

import { HttpErrorResponse } from '@angular/common/http';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AuthentificationService } from '@app/authentification/authentification.service';
import { UserAuthentified } from '@app/authentification/user-authentified.interface';
import { UserDao } from '@app/dao/user/user.dao';
import { PledgeRead } from '@app/forms/subscription/definition/interface/Pledge';
import { CompanyFieldType } from '@app/forms/subscription/definition/interface/enum';
import { URL_SIGNER } from '@app/forms/subscription/services/ref';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { HttpApiService } from '@app/providers/http-api/http-api.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import {
  EMPTY,
  Observable,
  Subject,
  throwError,
  catchError,
  delay,
  finalize,
  map,
  switchMap,
  take,
  takeWhile,
  tap,
} from 'rxjs';

import {
  applyPickedGedDocument,
  getDocumentRoute,
  resetDocumentForm,
} from '../utile';
import { EaDocumentFormBuilder } from './ea-subscription-form.builder';
const DOCUMENT_TYPE = 'FACTURE_TELEPHONE';
@UntilDestroy()
@Component({
  selector: 'phone-bill-form',
  templateUrl: './phone-bill-form.component.html',
  styleUrls: ['./phone-bill-form.component.scss'],
  standalone: false,
})
export class PhoneBillFormComponent
  extends EaDocumentFormBuilder
  implements OnInit
{
  files: File[] = [];

  file: any;

  error: string;

  user: UserAuthentified;
  private alive = true;
  documents: any;
  docLoading: boolean = false;

  doneSubject: Subject<void> = new Subject<void>();
  obser$: any;
  formData: any;

  documentId: any;
  pledge: PledgeRead;
  PHONE_BILL_DOCUMENT: boolean;
  safeUrl: SafeResourceUrl = '';
  displayDocumentLoading: boolean = false;

  gedDocuments = [DOCUMENT_TYPE];

  constructor(
    protected formConstructor: PrFormConstructor,
    private documentDao: DocumentDao,
    protected authenticationService: AuthentificationService,
    protected subscriptionFacade: SubscriptionFacadeService,
    private userDao: UserDao,
    private cdr: ChangeDetectorRef,
    private httpApiService: HttpApiService,
    private sanitizer: DomSanitizer,
  ) {
    super(formConstructor, subscriptionFacade, authenticationService);
  }

  ngOnInit() {
    this.pledge = this.subscriptionFacade.getPledge();
    this.PHONE_BILL_DOCUMENT =
      this.pledge?.parameters?.additionalQuestions?.find(
        q => q?.id === CompanyFieldType.PHONE_BILL_DOCUMENT,
      )?.required === 'MANDATORY';

    this.loading = true;
    this.initForm(
      {
        document: DOCUMENT_TYPE,
      },
      { ...this.pledge?.parameters },
    );
    this.obser$ = this.userDao.getAuthentified().pipe(
      switchMap(user => {
        this.user = user;

        return this.documentDao.searchDocument(user.accountId, {
          documents: [DOCUMENT_TYPE],
        });
      }),
      takeWhile(() => this.alive),
      map((resp: any) => {
        return resp.find(doc => doc.document === DOCUMENT_TYPE) || {};
      }),
      tap(resp => {
        this.initForm(
          { ...resp, document: DOCUMENT_TYPE },
          { ...this.pledge?.parameters },
        );
      }),
      tap(() => {
        this.displayDocument().subscribe();
      }),
      take(1),
      catchError(err => {
        this.loading = false;
        return err;
      }),
      finalize(() => {
        this.loading = false;
        this.cdr.detectChanges();
      }),
    );
  }

  onLoadFiles(files: any) {
    this.files = files;
    if (this.files.length > 0) {
      this.error = null;
    }
  }

  get title() {
    return 'Téléchargez votre facture de téléphone';
  }
  downloadDocument() {
    const doc = this.entity;
    const route = getDocumentRoute(doc.id, this.user?.accountId);
    this.docLoading = true;
    this.httpApiService
      .getWithOptions(route, {
        responseType: 'arraybuffer',
      })
      .pipe(
        take(1),
        finalize(() => {
          this.docLoading = false;
        }),
      )
      .subscribe(resp => {
        this.createLink(resp, doc);

        this.docLoading = false;

        this.cdr.detectChanges();
      });
  }

  private createLink(resp: any, doc: any) {
    const blob = new Blob([resp], { type: 'application/pdf' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = `${doc.label}.pdf`;
    link.click();
    // a test
    document.body.removeChild(link);
  }

  deleteDocument(doc) {
    const route = getDocumentRoute(doc.id, this.user?.accountId);
    this.httpApiService
      .delete(route)
      .pipe(take(1))
      .subscribe(() => {
        resetDocumentForm(this, DOCUMENT_TYPE);
        this.cdr.detectChanges();
      });
  }
  onSubmit() {
    if (!this.files.length && !this.form.get('id')?.value) {
      if (this.PHONE_BILL_DOCUMENT) {
        this.error = 'Veuillez saisir au moins un fichier';
        return;
      } else {
        this.subscriptionFacade.nextStep();
        return;
      }
    } else {
      this.prFormService.loading();
      const formData = new FormData() as any;
      for (const file of this.files) {
        formData.append('documentsFiles', file);
      }

      const obj = this.extractDocument().getRawValue();

      const payloadDocument = this.formatPayloadForSubmitDocument(obj);

      formData.append(
        'document',
        new Blob([JSON.stringify(payloadDocument)], {
          type: 'application/json',
        }),
      );

      this.formData = formData;

      this.onSave().subscribe(
        success => {
          this.prFormService.loaded();
          this.doneSubject.next();
        },
        errors => {
          console.error(errors);
          this.prFormService.loaded();
          this.notificationService.error('La sauvegarde a échoué');
        },
      );
    }
  }

  private formatPayloadForSubmitDocument(payload: any) {
    return {
      label: payload.label,
      dateCreated: payload.dateCreated,
      reviewed: payload.reviewed,
      isSigned: payload.isSigned,
      accountId: payload.accountId,
      category: payload.category,
      dateExpired: payload.dateExpired,
      document: payload.document,
      id: payload.id,
      ownerIds:
        payload.ownerIds && payload.ownerIds.length
          ? payload.ownerIds
          : payload.ownerIds
            ? [payload.ownerIds]
            : [],
    };
  }

  onSave() {
    if (!this.form.get('id').value) {
      return this.createDocument(this.formData);
    } else {
      return this.updateDocument();
    }
  }

  updateDocument() {
    return this.documentDao
      .putDocument(this.extractDocument().getRawValue(), this.user.accountId)
      .pipe(
        take(1),
        tap(resp => {
          this.documentId = resp.id;
          this.subscriptionFacade.submitPledgeWithoutForm(this);
        }),
      );
  }
  createDocument(formData) {
    return this.documentDao.saveDocument(formData, this.user.accountId).pipe(
      take(1),
      tap(resp => {
        this.documentId = resp.id;
        this.subscriptionFacade.submitPledgeWithoutForm(this);
      }),
    );
  }
  extract() {
    return {
      cellphoneBillId: this.documentId,
    };
  }

  onGedDocumentSelected(doc: any) {
    applyPickedGedDocument(this, doc, DOCUMENT_TYPE);
    this.cdr.detectChanges();
  }

  withdraw() {
    resetDocumentForm(this, DOCUMENT_TYPE);
    this.cdr.detectChanges();
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
  printFormData(formData: FormData) {
    formData.forEach((value, key) => {
      console.log(key, value);
    });
  }
  openLink() {
    window.open(URL_SIGNER, '_blank');
  }

  displayDocument(): Observable<any> {
    if (!this.entity?.id) {
      return EMPTY;
    }
    this.displayDocumentLoading = true;
    const doc = this.entity;

    const route = getDocumentRoute(doc.id, this.user?.accountId);

    this.httpApiService.getWithOptions(route, {
      responseType: 'arraybuffer',
    });

    return this.httpApiService
      .getWithOptions(route, {
        responseType: 'arraybuffer',
      })
      .pipe(
        untilDestroyed(this),
        take(1),
        delay(1000),
        tap((documentContent: ArrayBuffer) => {
          this.createIFrame(documentContent);
        }),
        catchError((error: HttpErrorResponse) => {
          console.error(error);
          this.displayDocumentLoading = false;
          return throwError(error);
        }),
        finalize(() => {
          this.displayDocumentLoading = false;
        }),
      );
  }
  createIFrame(resp) {
    let blob = new Blob([resp], { type: 'application/pdf' });
    let dataUrl = window.URL.createObjectURL(blob);

    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(dataUrl);

    this.displayDocumentLoading = true;
  }
}
